export default "__VITE_ASSET__sMuA8je1__"